import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Carousel from 'nuka-carousel';

import styles from './Confirmation.module.css';

class Confirmation extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    return (
      <div>
        { !this.props.isLongHaul ?
          <div className={styles.confirmationPageWrapper +' '+ styles.isShortHaul}>
            <div className={styles.confirmationPageShortHaul}>
              <div className={styles.confirmationPageHero}>
                <img src={require('./img/hero.jpg')} alt="" />
                <div>
                  <h2>You are going to Santa Barbara!</h2>
                  <p>1 person  •  {this.props.startDate.format('MMMM D')} - {this.props.endDate.format('MMMM D')} </p>
                </div>
              </div>

              <div className={styles.confirmationPageNext}>
                <h3>Next steps</h3>
                <ul>
                  <li>Share flight information</li>
                  <li>Book a home</li>
                  <li>Check out experiences</li>
                  <br/>
                  <br/>
                  <br/>
                </ul>
              </div>
            </div>
          </div>
        :
          <div className={styles.confirmationPageWrapper +' '+ styles.isLongHaul}>
            <div className={styles.confirmationPageHero}>
              <img src={require('./img/congrats.jpg')} style={{ width: '100%' }} alt="" />
            </div>

            <div className={styles.success}>
              <small>SUCCESS!</small>
              <h2>You’re all set to fly to Sydney, Australia.</h2>
              <p>We’ve added your flights to your Itinerary and sent a copy of the flight details your email. </p>
            </div>

            <div className={styles.perks}>
              <div className={styles.perksHeader}>
                <h3>Travel Perks</h3>
                <p>As an Airbnb Above member, you have access to exclusive member perks. Check them out here or view them at a later date from your itinerary.</p>
              </div>
              <Carousel
                className = {styles.carousel}
                //renderBottomCenterControls={null}
                renderCenterLeftControls={null}
                renderCenterRightControls={null}
                initialSlideHeight={510}
                initialSlideWidth={335}
                cellSpacing={20}
                dragging
              >
                <div className={styles.slide}>
                  <img className={styles.tipImage} src={require('./img/tips/tip1.jpg')} alt="" />
                </div>
                <div className={styles.slide}>
                <img className={styles.tipImage} src={require('./img/tips/tip2.jpg')} alt="" />
                </div>
                <div className={styles.slide}>
                  <img className={styles.tipImage} src={require('./img/tips/tip3.jpg')} alt="" />
                </div>
                <div className={styles.slide}>
                  <img className={styles.tipImage} src={require('./img/tips/tip4.jpg')} alt="" />
                </div>
                <div className={styles.slide}>
                  <img className={styles.tipImage} src={require('./img/tips/tip5.jpg')} alt="" />
                </div>
              </Carousel>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ main }) => ({
  isLongHaul: main.isLongHaul,
  startDate: main.startDate || moment().day(5 + 7),
  endDate: main.endDate || moment().day(7 + 7),
});

export default connect(mapStateToProps)(Confirmation);



// WEBPACK FOOTER //
// ./src/components/Confirmation/Confirmation.jsx